import { useAppDispatch, useAppSelector } from 'appState/store'
import { NavLinkWithTooltip } from 'components/Layout'
import { TopNav } from 'components/Navs'
import { PathsEnum } from 'pages/Paths'
import { useEffect, useState } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { Badge } from '@outbound-ai/ursa'
import styled from 'styled-components'

import { filterColorMapping, pathSliceViewMapping } from '../constants'
import { updateCurrentFiles } from '../FileShareSlice'
import {
  FileExchangeSourceEnum,
  FileExchangeStatus,
  FileExchangeTypeEnum,
  FileShareTabType,
} from '../types/FileShareEnums'
import { getFileList } from '../utils/fileShareApi'
import { isCurrentUserOutboundUser } from 'utils/helper'

export const FileShareTabs = () => {
  const location = useLocation()
  const currentTab = location.pathname.split('/').pop() as keyof typeof pathSliceViewMapping
  const [filesCount, setFilesCount] = useState(0)
  const dispatch = useAppDispatch()
  const { refresh } = useAppSelector((state) => state.fileShare)

  useEffect(() => {
    const isOutboundUser = isCurrentUserOutboundUser()
    const fileSource = isOutboundUser ? FileExchangeSourceEnum.OutboundAi : FileExchangeSourceEnum.Customer
    const fileType = FileExchangeTypeEnum.Onboarding
    const fileStatus = FileExchangeStatus.Uploaded

    getFileList(fileSource, fileType, fileStatus).then((res) => {
      if (res) {
        const count = res.data.resultCount
        setFilesCount(count)
      }
    })
    if (refresh) {
      dispatch(updateCurrentFiles({ root: FileShareTabType.Files, refresh: false }))
    }
  }, [refresh])

  return (
    <Div>
      <div className="tabs-nav-container">
        <div className="table-header">
          <TopNav activeLinkThemeColor={filterColorMapping[currentTab]}>
            <NavLinkWithTooltip to={PathsEnum.fileShareFiles} overlay={''}>
              <div className="d-flex align-items-center justify-content-center gap-2 p-relative">
                <span>Files</span>
                <Badge variant="badge" type="info">
                  {filesCount}
                </Badge>
              </div>
            </NavLinkWithTooltip>
          </TopNav>
        </div>
        <Outlet />
      </div>
    </Div>
  )
}

const Div = styled.div`
  .table-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    border-bottom: ${({ theme }) => theme.util.pixelToRem(1)} solid ${({ theme }) => theme.colors.primary.lighter};
    z-index: ${({ theme }) => theme.zIndex.sticky};
  }
`
